import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import ProfileCard from "./ProfileCard/ProfileCard";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  title: {
    textAlign: "center"
  }
}));

export default function Profiles(props) {
  const classes = useStyles();

  return (
    <Container maxWidth="md">
      <div className={classes.root}>
        <Typography
          variant={"h6"}
          style={{ paddingBottom: "0.7em" }}
          className={classes.title}
        >
          Gruppemedlemmer
        </Typography>
        <Grid container spacing={3}>
          {props.profiles.map(profile => (
            <Grid key={profile.name} item xs>
              <ProfileCard
                key={profile.name}
                name={profile.name}
                picture={profile.picture}
              />
            </Grid>
          ))}
        </Grid>
      </div>
    </Container>
  );
}
